import { render, staticRenderFns } from "./PartnerUpdate.vue?vue&type=template&id=4efab16e"
import script from "./PartnerUpdate.vue?vue&type=script&lang=js"
export * from "./PartnerUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports